import { render, staticRenderFns } from "./managePublic.vue?vue&type=template&id=3d8f666f&scoped=true"
import script from "./managePublic.vue?vue&type=script&lang=js"
export * from "./managePublic.vue?vue&type=script&lang=js"
import style0 from "./managePublic.vue?vue&type=style&index=0&id=3d8f666f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8f666f",
  null
  
)

export default component.exports